var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"styles":{ height: _vm.height, maxHeight: _vm.height }}},[(_vm.header)?_c('h2',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.header))]):_vm._e(),(_vm.description)?_c('div',{staticClass:"description"},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")]):_vm._e(),(_vm.loading)?_c('div',[_c('NumeraiLoader')],1):_vm._e(),_c('canvas',{ref:"canvas",style:({
      display: _vm.loading ? 'none' : 'block',
      height: _vm.height,
      maxHeight: _vm.height,
    }),attrs:{"height":_vm.height,"width":"fullwidth"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }